// recaptchaHelpers.js
let recaptchaPromise = null;

// ✅ Single source of truth for your SITE KEY (Enterprise site key)
export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6Lc5k3IrAAAAAF2DEb1X6rKYBs44JEi9u2cup_cw"; // your site key

export function loadRecaptchaScript() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Cannot load reCAPTCHA on the server"));
  }

  if (recaptchaPromise) return recaptchaPromise;

  recaptchaPromise = new Promise((resolve, reject) => {
    const finishIfReady = () => {
      const greRaw = window.grecaptcha;
      if (!greRaw || !greRaw.enterprise) return false;

      const gre = greRaw.enterprise;

      if (typeof gre.ready === "function") {
        gre.ready(() => resolve());
      } else {
        resolve();
      }
      return true;
    };

    // Already loaded
    if (window.grecaptcha && window.grecaptcha.enterprise) {
      if (!finishIfReady()) {
        return reject(new Error("reCAPTCHA present but not usable"));
      }
      return;
    }

    // If script tag is already present, just poll
    const existing = document.getElementById("recaptcha-script");
    if (existing) {
      let attempts = 0;
      const poll = () => {
        attempts++;
        if (finishIfReady()) return;
        if (attempts > 50) {
          reject(new Error("reCAPTCHA failed to initialize"));
        } else {
          setTimeout(poll, 100);
        }
      };
      return poll();
    }

    if (!RECAPTCHA_SITE_KEY) {
      return reject(new Error("Missing reCAPTCHA site key"));
    }

    // ✅ IMPORTANT: enterprise.js
    const script = document.createElement("script");
    script.id = "recaptcha-script";
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      let attempts = 0;
      const check = () => {
        attempts++;
        if (finishIfReady()) return;
        if (attempts > 50) {
          reject(new Error("reCAPTCHA did not load in time"));
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    };

    script.onerror = () =>
      reject(new Error("Failed to load reCAPTCHA script"));

    document.head.appendChild(script);
  });

  return recaptchaPromise;
}

export async function executeRecaptcha(action = "book_appointment") {
  if (typeof window === "undefined") {
    throw new Error("reCAPTCHA cannot run on the server");
  }

  if (!RECAPTCHA_SITE_KEY) {
    throw new Error("Missing reCAPTCHA site key");
  }

  await loadRecaptchaScript();

  const greRaw = window.grecaptcha;
  const gre = greRaw && greRaw.enterprise;

  if (!gre || typeof gre.execute !== "function") {
    console.error("grecaptcha.enterprise object:", greRaw);
    throw new Error("reCAPTCHA enterprise execute method is not available");
  }

  if (typeof gre.ready === "function") {
    await new Promise((resolve) => gre.ready(resolve));
  }

  const token = await gre.execute(RECAPTCHA_SITE_KEY, { action });

  console.log("reCAPTCHA token (FE):", {
    length: token && token.length,
    preview: token && token.substring(0, 20),
  });

  // ✅ VERY IMPORTANT: return the token
  return token;
}
